
module dg.objects {

    interface IValidationsExtensionScope extends ng.IScope {
        domainObjectCtrl: ObjectEditorController;
        propMeta: dg.restfulApi.DomainObjectPropertyMetadata;
        validationMessages: any;
    }

    class DgValidationFunctions {

        public server(scope: IValidationsExtensionScope, ctrl: ng.INgModelController) {
            return function (modelValue, viewValue) {

                //let propInput = scope.domainObjectCtrl.form[scope.propMeta.id];

                return true;
                //return propInput.$error.server && propInput.$pristine;
            };
        }
        public notNull(scope: IValidationsExtensionScope, ctrl: ng.INgModelController, rule: dg.restfulApi.ValidationRule) {
            return function (modelValue, viewValue) {
                return angular.isArray(viewValue) ? viewValue.length != 0 : !ctrl.$isEmpty(viewValue);
            };
        }

        public pattern(scope: IValidationsExtensionScope, ctrl: ng.INgModelController, rule: dg.restfulApi.ValidationRule) {
            return function (modelValue, viewValue) {
                var value = modelValue || viewValue;
                return ctrl.$isEmpty(value) || new RegExp(rule.params['pattern']).test(value);
            };
        }

        public length(scope: IValidationsExtensionScope, ctrl: ng.INgModelController, rule: dg.restfulApi.ValidationRule) {
            return function (modelValue, viewValue) {
                var value = modelValue || viewValue;
                return !angular.isString(value) || (value.length >= rule.params['minLength'] && value.length <= rule.params['maxLength']);
            };
        }

        public date(scope: IValidationsExtensionScope, ctrl: ng.INgModelController, rule: dg.restfulApi.ValidationRule) {
            return (modelValue, viewValue) => {
                //return ctrl.$error.Date;
                return true;
            };
        }

        public dateRangeLength(scope: IValidationsExtensionScope, ctrl: ng.INgModelController, rule: dg.restfulApi.ValidationRule) {
            return (modelValue, viewValue) => {
                let value = modelValue || viewValue;

                if (!value) {
                    return true;
                }
                else if (value.min && value.max) {
                    let minDate = new Date(value.min);
                    let maxDate = new Date(value.max);
                    let timeDiff = Math.abs(maxDate.getTime() - minDate.getTime());
                    let diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));

                    return diffDays >= rule.params['min'] && diffDays <= rule.params['max'];
                }

                return true;
            };
        }

        private tryParseDateValue(val) {
            let date = Date.parse(val);
            if (!isNaN(date)) {
                val = new Date(val);
            }

            return val;
        }

        public compare(scope: IValidationsExtensionScope, ctrl: ng.INgModelController, rule: dg.restfulApi.ValidationRule) {
            let compareToValue = (rule: dg.restfulApi.ValidationRule): any => {
                let val = rule.params['comparisonValue'];
                if (rule.params['memberComparison']) {

                    if (scope.propMeta.dataType == dg.restfulApi.DG_DATA_TYPES.Date || scope.propMeta.dataType == dg.restfulApi.DG_DATA_TYPES.DateTime) {
                        //should work only for dates
                        val = this.tryParseDateValue(scope.domainObjectCtrl.value[val]);
                    }
                }

                return val;
            };

            let compareFuncs = {
                Equal: (val, comparator) => val == comparator,
                NotEqual: (val, comparator) => val != comparator,
                LessThan: (val, comparator) => val < comparator,
                LessThanOrEqual: (val, comparator) => val <= comparator,
                GreaterThan: (val, comparator) => val > comparator,
                GreaterThanOrEqual: (val, comparator) => val >= comparator,
            };

            let compareFunc = (val, rule: dg.restfulApi.ValidationRule) => {
                let result = true;
                if (val) {
                    let comparator = compareToValue(rule);
                    let comparison = rule.params['comparison'];
                    result = compareFuncs[comparison](val, comparator);
                }

                return result;
            };

            return function (modelValue, viewValue) {

                var value = modelValue || viewValue;
                return compareFunc(value, rule);
            };
        }
    }


    function validationExtension($parse): ng.IDirective {
        return {
            restrict: 'A',
            require: ['ngModel', '^objectEditor'],
            link: (scope: IValidationsExtensionScope, instanceElement: ng.IAugmentedJQuery, instanceAttributes: ng.IAttributes, ctrls: ng.IController[], transclude: ng.ITranscludeFunction) => {
                scope.domainObjectCtrl = <ObjectEditorController>ctrls[1];
                let ngModelCtrl = <ng.INgModelController>ctrls[0];

                var dgValidationFunctions = new DgValidationFunctions();
                scope.validationMessages = {};
                
                if (scope.propMeta.extensions && scope.propMeta.extensions.validation) {
                    angular.forEach(scope.propMeta.extensions.validation.rules, (rule: dg.restfulApi.ValidationRule, ruleName: string) => {
                        var funcName = rule.type.charAt(0).toLowerCase() + rule.type.slice(1);

                        scope.validationMessages[rule.code] = rule.message;
                        ngModelCtrl.$validators[rule.code] = dgValidationFunctions[funcName](scope, ngModelCtrl, rule);
                    });

                    ngModelCtrl.$validators['server'] = dgValidationFunctions.server(scope, ngModelCtrl);
                }
            }
        };
    }

    angular.module('dg.objects')
        .directive('validationExtension', validationExtension);


}